import type { ApiUser } from '../http/oracle-api-client';

export const BROWSER_AUTHENTICATION_CACHE_TTL_MS = 60_000;

let currentUser: ApiUser | null | undefined;
let currentUserExpiresAt = 0;

export const primeBrowserAuthenticatedUser = (
  user: ApiUser | null,
  now = Date.now(),
) => {
  currentUser = user;
  currentUserExpiresAt = now + BROWSER_AUTHENTICATION_CACHE_TTL_MS;
};

export const readBrowserAuthenticatedUser = (now = Date.now()) => {
  if (currentUser !== undefined && now >= currentUserExpiresAt) {
    clearBrowserAuthenticatedUser();
  }
  return currentUser;
};

export const clearBrowserAuthenticatedUser = () => {
  currentUser = undefined;
  currentUserExpiresAt = 0;
};
